<button>Profil</button>

<div class="container" style="margin-top: 5rem;">
    <div class="row text-start">
        <a (click)="backClicked()"><i class="fas fa-arrow-circle-left fa-3x"></i></a>
    </div>
    <pdf-viewer src=" {{this.authService.values ? this.authService.values.message.speisekarte : '' }} " [original-size]="false" style="display: block;"></pdf-viewer>
</div>